import Atest from '@/pages/Atest';
import M1 from "@/pages/M1";
import Y2 from "@/pages/Y2";
// import Y1 from "@/pages/Y1";
import E404 from "@/pages/E404";
import Fail from '@/pages/Fail';
import Y1menu from "@/pages/Y1menu";
import Ylso1 from '@/pages/Ylso1';
import Ylso2 from '@/pages/Ylso2';

import Murl from "@/pages/Murl";
import { createBrowserRouter } from 'react-router-dom';


const router = createBrowserRouter([
    {
        path: "/",
        element: <M1 />, children: [
            {
                path: "f",
                element: <Y1menu />
                
            },
            {
                path: "*",
                element: <E404 />
            },
            {
                path: "fail",
                element: <Fail />
            },
            {
                path: "s",
                element: <Y2></Y2>
            }
            ,
            {
                path: "img",
                element: <Ylso1/>
            }
            ,
            {
                path: "zcy",
                element: <Ylso2/>
            }
            ,{
                path: "",
                element: <Atest></Atest>
            }
            
        ]
    },
     {
         path: "/:dbno/:dbtype/:dbcode",
         element: <Murl />
     },
])
export default router